import { MutableRefObject, useCallback, useRef } from 'react';

type HistoricalVisitPrescriptionsOverlayRefs = {
   readonly setContainerRef: (el: HTMLDivElement | null) => void;
   readonly createItemRef: (prescriptionId: number) => (el: HTMLElement | null) => void;
   readonly getItemRef: (prescriptionId: number) => MutableRefObject<HTMLElement | null>;
};

export const useHistoricalVisitPrescriptionsOverlayRefs = (
   backdropElementRef?: MutableRefObject<HTMLElement | null>
): HistoricalVisitPrescriptionsOverlayRefs => {
   const itemRefs = useRef<Map<number, HTMLElement | null>>(new Map());

   const setContainerRef = useCallback(
      (el: HTMLDivElement | null) => {
         if (backdropElementRef) {
            backdropElementRef.current = el;
         }
      },
      [backdropElementRef]
   );

   const createItemRef = useCallback((prescriptionId: number) => {
      return (el: HTMLElement | null) => {
         itemRefs.current.set(prescriptionId, el);
      };
   }, []);

   const getItemRef = useCallback((prescriptionId: number): MutableRefObject<HTMLElement | null> => {
      return {
         get current() {
            return itemRefs.current.get(prescriptionId) ?? null;
         },
         set current(el: HTMLElement | null) {
            itemRefs.current.set(prescriptionId, el);
         },
      };
   }, []);

   return { setContainerRef: setContainerRef, createItemRef: createItemRef, getItemRef: getItemRef };
};
